/**
 * UI / bootstrap / utilities error codes.
 */
export enum UiErrorCode {
  BOOTSTRAP_LOAD_FAILED = 'error.ui.bootstrap_load.failed',
  EINVOICE_VALIDATION_FAILED = 'error.ui.einvoice_validation.failed',
  SAVE_SECTION_FAILED = 'error.ui.save_section.failed',
  LOGS_SERIALIZE_FAILED = 'error.ui.logs_serialize.failed',
  LOGS_STATS_FAILED = 'error.ui.logs_stats.failed',
  ANALYTICS_LOG_FAILED = 'error.ui.analytics_log.failed',
  HELPER_FAILED = 'error.ui.helper.failed',
  SCRIPT_LOAD_FAILED = 'error.ui.script_load.failed',
  UNHANDLED_REJECTION = 'error.ui.unhandled_rejection',
}
